<div class="driver-modal">
  <div class="sec_head">
    <h2>{{ (data.data ? 'EditTeam' : 'AddTeam') | translate }}</h2>
  </div>
  <div class="modal-body">
    <form
      class="attribute-modal"
      [formGroup]="teamFormGroup"
      (ngSubmit)="onSubmit()">
      <div class="form_feilds gap_m">
        <div class="form_group w_100">
          <mat-label class="required"> {{ 'teamName' | translate }}</mat-label>
          <mat-form-field appearance="fill">
            <input
              matInput
              formControlName="teamName"
              placeholder=" {{ 'teamName' | translate }}"
              class="form_control" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              teamFormGroup.controls['teamName'].hasError('required')
            ">
            {{ 'teamName' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted &&
              teamFormGroup.controls['teamName'].hasError('maxlength')
            ">
            {{ 'teamName' | translate }}
            {{ 'Upto40Char' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted &&
              teamFormGroup.controls['teamName'].hasError('minlength')
            ">
            {{ 'teamName' | translate }}
            {{ 'Atleast3Char' | translate }}
          </mat-error>
        </div>

        <div class="form_group w_100">
          <mat-label class="required"> {{ 'Geofence' | translate }}</mat-label>
          <mat-form-field>
            <mat-select
              [ngClass]="{
                hd_drop: data.data
              }"
              class="form_control"
              placeholder="{{ 'Geofence' | translate }}"
              formControlName="geofenceId">
              <mat-option
                [value]="item._id"
                *ngFor="let item of geofenceList">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              teamFormGroup.controls['geofenceId'].hasError('required')
            ">
            {{ 'Geofence' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
        </div>

        <!-- <div class="form_group w_100">
          <mat-label class="required"> {{ 'Drivers' | translate }}</mat-label>
          <mat-form-field>
            <mat-select
              [placeholder]="getPlaceholder() | translate"
              class="form_control"
              formControlName="drivers"
              multiple>
              <mat-option [value]="item._id" *ngFor="let item of driverList">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              teamFormGroup.controls['drivers'].hasError('required')
            ">
            {{ 'Drivers' | translate }} {{ 'IsRequired' | translate }}
          </mat-error>
        </div> -->
      </div>
      <div class="submit_btn">
        <button type="submit" class="btnn btn_primary">
          {{ 'Submit' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
